// extracted by mini-css-extract-plugin
export default {"hero":"SmallHero__hero--9i","xs":"SmallHero__xs--TW","md":"SmallHero__md--rm","sm":"SmallHero__sm--g1"};